import Head from 'next/head';
import React from 'react';
import { ArticlesList } from '../components';
import { withLayout } from '../Layout/Layout';

function TopLists() {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/cruises`} />
        <meta
          name="description"
          content={
            'Embark on a journey of luxury cruising with First-Class.com. Explore cruise options, itineraries, and exquisite onboard experiences'
          }
        />
        <title>Cruises: Luxury Cruising Experiences</title>
      </Head>
      <ArticlesList type="Cruises" heading="Cruises" />
    </>
  );
}

export default withLayout(TopLists, true);
